var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSiteRewrite } from '@sitecore-jss/sitecore-jss/site';
import { BaseGraphQLSitemapService, languageError, } from './base-graphql-sitemap-service';
export const sitesError = 'The list of sites cannot be empty';
/**
 * Service that fetches the list of site pages using Sitecore's GraphQL API.
 * Used to handle multiple sites
 * This list is used for SSG and Export functionality.
 * @mixes SearchQueryService<PageListQueryResult>
 */
export class MultisiteGraphQLSitemapService extends BaseGraphQLSitemapService {
    /**
     * Creates an instance of graphQL sitemap service with the provided options
     * @param {MultisiteGraphQLSitemapServiceConfig} options instance
     */
    constructor(options) {
        super(options);
        this.options = options;
    }
    /**
     * Fetch a flat list of all pages that belong to all the requested sites and have a
     * version in the specified language(s).
     * @param {string[]} languages Fetch pages that have versions in this language(s).
     * @param {Function} formatStaticPath Function for transforming the raw search results into (@see StaticPath) types.
     * @returns list of pages
     * @throws {RangeError} if the list of languages is empty.
     * @throws {RangeError} if the any of the languages is an empty string.
     */
    fetchSitemap(languages, formatStaticPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const paths = new Array();
            if (!languages.length) {
                throw new RangeError(languageError);
            }
            // Get all sites
            const sites = this.options.sites;
            if (!sites || !sites.length) {
                throw new RangeError(sitesError);
            }
            // Fetch paths for each site
            for (let i = 0; i < sites.length; i++) {
                const siteName = sites[i];
                // Fetch paths using all locales
                paths.push(...(yield this.getTranformedPaths(siteName, languages, formatStaticPath)));
            }
            return [].concat(...paths);
        });
    }
    /**
     * Fetch and return site paths for multisite implementation, with prefixes included
     * @param {string} language path language
     * @param {string} siteName site name
     * @returns modified paths
     */
    fetchLanguageSitePaths(language, siteName) {
        const _super = Object.create(null, {
            fetchLanguageSitePaths: { get: () => super.fetchLanguageSitePaths }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield _super.fetchLanguageSitePaths.call(this, language, siteName);
            results.forEach((item) => {
                if (item) {
                    item.path = getSiteRewrite(item.path, { siteName: siteName });
                }
            });
            return results;
        });
    }
}
